module.exports = __webpack_public_path__ + "static/media/55.ef48515f.mp4";